import { FormGroup, FormParagraph, FormSection, Radio, RadioGroup } from '@ksyos/design-system';
import { ServiceCode } from '@common/enums';
import { translateKey } from '@frontend/translate';
import { ServiceOrganizationSettingFormMode } from '../ServiceOrganizationSetting';

interface IDiagnosticEquipmentFormSectionReadProps extends IDiagnosticEquipmentFormSectionProps {
    mode: ServiceOrganizationSettingFormMode.read;
}

interface IDiagnosticEquipmentFormSectionEditProps extends IDiagnosticEquipmentFormSectionProps {
    handleChange: (value: boolean | null) => void;
    mode: ServiceOrganizationSettingFormMode.edit;
}

interface IDiagnosticEquipmentFormSectionProps {
    canPerformGlaucoomExamination: boolean | null;
    serviceCode: ServiceCode;
}

export function DiagnosticEquipmentFormSection(
    props: IDiagnosticEquipmentFormSectionReadProps | IDiagnosticEquipmentFormSectionEditProps
) {
    if (props.serviceCode !== ServiceCode.TOO) {
        return null;
    }

    return (
        <FormSection title={translateKey('serviceOrganizationSetting.diagnosticEquipment')}>
            <FormGroup label={translateKey('serviceOrganizationSetting.canPerformGlaucoomExamination')}>
                {props.mode === ServiceOrganizationSettingFormMode.read ? (
                    <FormParagraph>
                        {props.canPerformGlaucoomExamination
                            ? translateKey('common.yes')
                            : props.canPerformGlaucoomExamination === false
                              ? translateKey('common.no')
                              : '-'}
                    </FormParagraph>
                ) : (
                    <RadioGroup
                        layout="row"
                        name="canPerformGlaucoomExamination"
                        onChange={(event) => props.handleChange(JSON.parse(event.target.value))}
                        value={JSON.stringify(props.canPerformGlaucoomExamination)}
                    >
                        <Radio
                            label={translateKey('common.yes')}
                            value="true"
                        />
                        <Radio
                            label={translateKey('common.no')}
                            value="false"
                        />
                        <Radio
                            label={translateKey('common.unknown')}
                            value="null"
                        />
                    </RadioGroup>
                )}
            </FormGroup>
        </FormSection>
    );
}
